import { Button } from "@knowtex-ai/components";

export type AddAnotherRecordingButtonProps = {
  locked?: boolean;
  onRecord: () => void;
  confirmLeave?: (proceed: () => void) => void;
};

/**
 * Footer control that leaves Review to start another recording.
 * When `confirmLeave` is provided (Review modal), Bootstrap's data-bs-dismiss
 * is omitted so the unsaved-changes gate can veto before navigation.
 */
export default function AddAnotherRecordingButton({
  locked = false,
  onRecord,
  confirmLeave,
}: AddAnotherRecordingButtonProps) {
  const handleClick = () => {
    if (locked) {
      return;
    }
    if (confirmLeave) {
      confirmLeave(onRecord);
      return;
    }
    onRecord();
  };

  return (
    <Button
      type="button"
      variant="secondary-alt"
      disabled={locked}
      aria-disabled={locked}
      {...(confirmLeave ? {} : { "data-bs-dismiss": "modal" })}
      onClick={handleClick}
    >
      Add a Recording
    </Button>
  );
}
